export default __webpack_public_path__ + "static/media/img_result_line3.eed57c03.svg";